import { apiV1 } from './api-v1';
import { ChatbotFeedbackResponse, ChatbotResponse, ChatbotSatisfaction } from '../models/chatbot.entity';

export const chatbotApi = {
  async initiateChatbot(clientId: string, clientRequest: string): Promise<ChatbotResponse> {
    try {
      const response = await apiV1.post<ChatbotResponse>(`/initiate`, {
        message: clientRequest,
        user_id: clientId,
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al inicializar el chatbot: ' + error);
    }
  },

  async responseChatbot(clientId: string, clientRequest: string, conversationId: string): Promise<ChatbotResponse> {
    try {
      const response = await apiV1.post<ChatbotResponse>(`/respond`, {
        message: clientRequest,
        user_id: clientId,
        conversation_id: conversationId,
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener la respuesta del chatbot: ' + error);
    }
  },

  async feedbackChatbot(
    clientId: string,
    satisfaction: ChatbotSatisfaction,
    conversationId: string,
  ): Promise<ChatbotFeedbackResponse> {
    try {
      const response = await apiV1.post<ChatbotFeedbackResponse>('/feedback', {
        conversation_id: conversationId,
        client_id: clientId,
        satisfaction,
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al enviar la retroalimentación del chatbot: ' + error);
    }
  },
};
